import React, { useState, useEffect, useContext, createContext, useMemo } from 'react';
import { get } from '@ts/utils/cs';

export const CookieContext = createContext(null);

export const CookieContextProvider = ({ children }) => {
    // const [cookies, setCookie] = useState();
    const [activities, setActivities] = useState([]);
    const [loadingContext, setLoading] = useState(true);

    // ComponentDidMount
    useEffect(() => {
        //Run Effects.
        getActivities();
    }, []);

    const getActivities = async () => {
        try {
            const json = await get('Recently_Viewed');
            if (json && Array.isArray(json)) {
                setActivities(
                    json.filter(
                        (activity) =>
                            activity &&
                            typeof activity === 'object' &&
                            typeof activity.name === 'string'
                    )
                );
            }
        } catch (err) {
            console.error(err);
        }

        setLoading(false);
    };

    //
    const values = useMemo(
        () => ({
            loadingContext,
            activities,
            getActivities,
        }),
        [loadingContext, activities]
    );

    // Finally, return the interface that we want to expose to our other components
    return <CookieContext.Provider value={values}>{children}</CookieContext.Provider>;
};

//
export function useCookieContext() {
    const context = useContext(CookieContext);
    return context;
}
